export const splitUtil = (value, charSplit, quantArrayUse) => {
    const arraySplit = value.split(charSplit);
    let result = "";
    let quantCanUse = 0;
    if (arraySplit.length >= quantArrayUse) {
        quantCanUse = quantArrayUse;
    } else {
        quantCanUse = arraySplit.length;
    }
    for (let i = 0; i < quantCanUse; i++) {
        result += arraySplit[i] + " ";
    }
    return result
}

